import {Capacitor} from "@capacitor/core";
import {addToast} from "@heroui/react";
import {CurrentEntitlementsResponse, Subscriptions} from "@squareetlabs/capacitor-subscriptions";
import {createContext, useContext, useEffect} from "react";

import {apiAction} from "./api.ts";
import {useJwtAuth, useJwtUser} from "./JWTAuthProvider.tsx";

const initialData: {} = {} as any;

const InAppStoreContext = createContext(initialData);

const InAppStoreProvider = ({children}) => {
    if (Capacitor.getPlatform() !== 'ios') {
        return <InAppStoreContext.Provider value={{
            enabled: false,
        }}>{children}</InAppStoreContext.Provider>;
    }

    const user = useJwtUser();
    const auth = useJwtAuth();

    useEffect(() => {
        if (user?.do_restore_purchases) {
            restorePurchases(false);
        }
    }, [user])

    async function subscribe(productId: string) {
        const response = await Subscriptions.purchaseProduct({
            productIdentifier: productId,
        })

        console.log('[in-app]', 'handleInAppStoreSubmit', response)

        const subscribed = await restorePurchases();

        console.log('[in-app]', 'handleInAppStoreSubmit subscribed', subscribed)

        return subscribed;
    }

    async function registerSubscriptions(receipts, showNotifications = true): Promise<void> {
        apiAction('in-app/register-subscription', {
            receipts: receipts,
        }).then((resp) => {
            if (resp.subscribed_now && showNotifications) {
                addToast({
                    color: "success",
                    title: "You are now subscribed to ScorePal Pro!",
                });
            }
            auth.reloadUser();
        })
    }

    async function getActiveSubscriptions(): Promise<any[]> {
        const response: CurrentEntitlementsResponse = await Subscriptions.getCurrentEntitlements();
        if (response.responseCode == 0) {
            console.log("[in-app] CurrentEntitlementsResponse", JSON.parse(JSON.stringify(response.data)));
            return response.data || [];
        } else {
            console.log("[in-app] CurrentEntitlementsResponse - empty");
            return [];
        }
    }

    async function restorePurchases(showNotifications = true) {
        console.log("[in-app] restorePurchases")

        const receipts = await getActiveSubscriptions();

        console.log('[in-app]', 'receipts', receipts)

        if (Object.values(receipts || {}).length) {
            await registerSubscriptions(receipts, showNotifications);
            return true;
        }
        return false;
    }

    function manageSubscriptions() {
        Subscriptions.manageSubscriptions();
    }

    return <InAppStoreContext.Provider value={{
        enabled:               true,
        subscribe, restorePurchases, manageSubscriptions,
        getActiveSubscription: getActiveSubscriptions,
    }}>{children}</InAppStoreContext.Provider>;
};

export const useInAppStore = (): any => {
    return useContext(InAppStoreContext);
};

export default InAppStoreProvider;
